import { toast } from 'sonner';
import { forViewer } from './audience';

/**
 * Error toast for failures that are not the user's input; the request id (req_…) is shown in mono. API text that names
 * a provider is reworded for clients (SPEC decision 23).
 */
export function showErrorToast(t: { title: string; description?: string }) {
  toast.error(forViewer(t.title), {
    description: t.description === undefined ? undefined : forViewer(t.description),
    descriptionClassName: t.description?.startsWith('req_') ? 'font-mono' : undefined,
    duration: 9000,
  });
}
